import React from 'react';
import Script from 'react-load-script';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { Location } from '@reach/router';
import { getPathFromUrlString, getProductNameFromUrlString, urlParamsFromObject } from '../../utils/url';
import './style.css';
import { Input, InputAdornment } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const productMap = {
    jet: 'JET',
    'media-shuttle': 'MEDIA SHUTTLE',
    flight: 'FLIGHT',
    'manager-agents': 'MANAGER+AGENTS',
};

const StyledInput = withStyles({
    input: {
        marginTop: '5px',
        fontSize: '12px',
        paddingTop: '5px',
    },
})(Input);

class DocSearch extends React.Component {
    state = {
        enabled: true,
        product: this.getProductName(),
        search: '',
    };
    constructor(props) {
        super(props);
        this.onSearchTermUpdate = this.onSearchTermUpdate.bind(this);
        this.enableSearch = this.enableSearch.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    componentDidUpdate() {
        let product = this.getProductName();
        if (this.state.product !== product) {
            this.setState({ product }, () => this.updateFacets(this.state.product));
        }
    }

    updateFacets(filter) {
        this.docsearch.algoliaOptions.facetFilters = [`product:${filter}`];
    }

    getProductName() {
        return getProductNameFromUrlString(this.props.location.href, false);
    }

    onFormSubmit(e) {
        // docsearch is unable to handle Return once the focus has shifted
        e.preventDefault();
        if (this.state.search === '') {
            return;
        }
        const urlParams = { product: this.state.product, query: this.state.search };
        navigate(`/${this.state.product}/search/?${urlParamsFromObject(urlParams)}`);
    }

    onSearchTermUpdate(e) {
        this.setState({ search: e.target.value });
    }

    enableSearch() {
        this.docsearch = window.docsearch({
            apiKey: '5df5f497e633e10f59c7b79a517d3fdd',
            appId: 'V69UUVP7D3',
            indexName: 'help-signiant-com',
            inputSelector: '#algolia-doc-search',
            debug: false,
            handleSelected: (input, event, suggestion, datasetNumber, context) => {
                if (context.selectionMethod === 'enterKey' && this.state.search !== '') {
                    const urlParams = { product: this.state.product, query: this.state.search };
                    navigate(`/${this.state.product}/search/?${urlParamsFromObject(urlParams)}`);
                } else {
                    navigate(getPathFromUrlString(suggestion.url).replace('#___gatsby', ''));
                }
                // On mobile, the onClick function will toggle the search bar
                this.props?.onClick();
            },
            algoliaOptions: {
                facetFilters: [`product:${this.state.product}`],
            },
        });
    }

    render() {
        const { enabled } = this.state;

        return enabled ? (
            <React.Fragment>
                <Script
                    url="https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.js"
                    onLoad={() => this.enableSearch()}
                />

                <form className="docSearchForm hidden-print" onSubmit={this.onFormSubmit}>
                    <StyledInput
                        className={'search-input-field'}
                        style={{ color: 'white', 'margin-right': '7px' }}
                        variant="outlined"
                        onChange={this.onSearchTermUpdate}
                        id="algolia-doc-search"
                        placeholder={`SEARCH ${productMap[this.state.product]} HELP `}
                        margin="dense"
                        startAdornment={<InputAdornment position={'start'}>{this.props.inputAdornment}</InputAdornment>}
                    />
                </form>
            </React.Fragment>
        ) : null;
    }
}

DocSearch.propTypes = {
    location: PropTypes.object.isRequired,
};

export default (props) => (
    <Location>{(locationProps) => <DocSearch {...locationProps} {...props}></DocSearch>}</Location>
);
